import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DescriptionComponent } from 'common/description/description.component';
import { TranslateModule } from '@ngx-translate/core';
import { RequirementExternalElement } from 'api';

@Component({
  selector: 'comp-example',
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DescriptionComponent, TranslateModule],
})
export class ExampleComponent {
  readonly example = input.required<RequirementExternalElement>();
}
